import React, { type PropsWithChildren } from 'react';
import { StyleSheet, type ViewProps } from 'react-native';
import Animated, { type AnimatedProps } from 'react-native-reanimated';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarLinksGroup = (props: Props) => {
  const { children, layout, style } = props;

  return (
    <Animated.View accessibilityRole="tablist" layout={layout} style={[styles.linkGroup, style]}>
      {children}
    </Animated.View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  linkGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['1'],
    padding: theme.spacing['1'],
    borderRadius: theme.radius['3xLarge'],
    backgroundColor: theme.colors.WHITE,
    boxShadow: '0px 0px 20px 0px rgba(14, 21, 14, 0.05)',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  layout?: AnimatedProps<ViewProps>['layout'];
  style?: ViewProps['style'];
}>;
